'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NavCategoryItemProvider: function() {
        return NavCategoryItemProvider;
    },
    useNavCategoryItemContext_unstable: function() {
        return useNavCategoryItemContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const NavCategoryItemContext = /*#__PURE__*/ _react.createContext(undefined);
const NavCategoryItemContextDefaultValues = {
    open: false
};
const { Provider: NavCategoryItemProvider } = NavCategoryItemContext;
const useNavCategoryItemContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(NavCategoryItemContext)) !== null && _React_useContext !== void 0 ? _React_useContext : NavCategoryItemContextDefaultValues;
};
